
// Reducer
import { combineReducers } from 'redux';


const initialState = {
    details: null,
}


const reducer = (state=initialState, action) => {
    if(action.type === 'SAVE_PERSON_RECORDS'){
        console.log(action.item)
        return {
            details: action.item
        }
    }

    return state;
}


export default combineReducers({reducer});